import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { DashboardOutlined, BarChartOutlined, PieChartOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

const POWER_BI_CONSOLE_URL = import.meta.env.VITE_HEPS_POWER_BI_CONSOLE_URL;

const IFrame = () => import('@/views/iframe/index.vue');

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/dashboard',
  //   name: 'dashboard',
  //   redirect: '/dashboard/console',
  //   component: Layout,
  //   meta: {
  //     title: 'Dashboard',
  //     icon: renderIcon(DashboardOutlined),
  //     //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
  //     permissions: ['dashboard_console', 'dashboard_monitor', 'dashboard_workplace'],
  //     sort: 1,
  //   },
  //   children: [
  //     {
  //       path: 'console',
  //       name: 'dashboard_console',
  //       meta: {
  //         title: 'Console',
  //         icon: renderIcon(BarChartOutlined),
  //         permissions: ['dashboard_console'],
  //         affix: true,
  //       },
  //       component: () => import('@/views/dashboard/monitor/monitor.vue'),
  //     },
  //   ],
  // },
  {
    path: '/dashboard',
    name: 'dashboard',
    redirect: '/dashboard/console',
    component: Layout,
    meta: {
      title: 'Dashboard',
      sort: 1,
      icon: renderIcon(DashboardOutlined),
      permissions: ['dashboard_console'],
    },
    children: [
      {
        path: 'console',
        name: 'dashboard_console',
        meta: {
          title: 'Console',
          icon: renderIcon(BarChartOutlined),
          permissions: ['dashboard_console'],
          frameSrc: POWER_BI_CONSOLE_URL,
          affix: true,
        },
        component: IFrame,
      },
    ],
  },
];

export default routes;
